var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpRightAndArrowDownLeftFromCenterLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "40px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B084EB93-3B58-47F5-9D68-D9B37FC5DA89") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-2",
    transform: "translate(-424.000000, -1138.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.250000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(414.000000, 1022.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-right-and-arrow-down-left-from-center-light",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8671875,15.3671875 C22.3828125,15.8515625 22.3828125,16.6484375 22.8671875,17.1328125 C23.3515625,17.6171875 24.1484375,17.6171875 24.6328125,17.1328125 L37.5,4.265625 L37.5,12.5 C37.5,13.1875 38.0625,13.75 38.75,13.75 C39.4375,13.75 40,13.1875 40,12.5 L40,1.25 C40,0.5625 39.4375,0 38.75,0 L27.5,0 C26.8125,0 26.25,0.5625 26.25,1.25 C26.25,1.9375 26.8125,2.5 27.5,2.5 L35.734375,2.5 L22.8671875,15.3671875 Z M17.1328125,24.6328125 C17.6171875,24.1484375 17.6171875,23.3515625 17.1328125,22.8671875 C16.6484375,22.3828125 15.8515625,22.3828125 15.3671875,22.8671875 L2.5,35.734375 L2.5,27.5 C2.5,26.8125 1.9375,26.25 1.25,26.25 C0.5625,26.25 0,26.8125 0,27.5 L0,38.75 C0,39.4375 0.5625,40 1.25,40 L12.5,40 C13.1875,40 13.75,39.4375 13.75,38.75 C13.75,38.0625 13.1875,37.5 12.5,37.5 L4.265625,37.5 L17.1328125,24.6328125 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightAndArrowDownLeftFromCenterLight);
export default __webpack_public_path__ + "static/media/arrow-up-right-and-arrow-down-left-from-center-light.4b346adc30f351db4fa4f5a00a3a5811.svg";
export { ForwardRef as ReactComponent };